// Utils
import { sentryErrorLog } from "@utils/sentryLog";
import { numberToCurrency } from "@utils/common";

export const getDefiData = async () => {
  const [beefyEllipsis, firestoreData] = await Promise.all([
    getBeefyEllipsisPool(),
    getFirestoreData(),
  ]);

  return {
    ...beefyEllipsis,
    ...firestoreData,
  };
};

export const getFirestoreData = async () => {
  try {
    const response = await fetch(
      `https://us-central1-stader-landing-ui.cloudfunctions.net/app/defi/${
        process.env.NEXT_PUBLIC_TOKEN?.toLowerCase() || ""
      }`
    );

    const resp = await response.json();
    return resp;
  } catch (error) {
    sentryErrorLog(error);
    return {
      error,
    };
  }
};

export const getBeefyEllipsisPool = async () => {
  try {
    const [tvlResponse, apyResponse] = await Promise.all([
      fetch("https://api.beefy.finance/tvl"),
      fetch("https://api.beefy.finance/apy"),
    ]);

    const tvlResp = await tvlResponse.json();
    const apyResp = await apyResponse.json();

    return {
      beefyEllipsis: {
        tvl: numberToCurrency(tvlResp["56"]["ellipsis-bnb-bnbx"]),
        apy: (+(apyResp["ellipsis-bnb-bnbx"] * 100)).toFixed(2).toString(),
        enable: true,
        showTVL: false,
      },
      beefyApeswap: {
        tvl: numberToCurrency(tvlResp["56"]["banana-bnbx-wbnb"]),
        apy: (+(apyResp["banana-bnbx-wbnb"] * 100)).toFixed(2).toString(),
        enable: true,
        showTVL: false,
      },
      beefyPancake: {
        tvl: numberToCurrency(tvlResp["56"]["cake-stable-bnbx-wbnb"]),
        apy: (+(apyResp["cake-stable-bnbx-wbnb"] * 100)).toFixed(2).toString(),
        enable: true,
        showTVL: false,
      },
      beefyThenaBNBXFrax: {
        tvl: numberToCurrency(tvlResp["56"]["thena-bnbx-frax"]),
        apy: (+(apyResp["thena-bnbx-frax"] * 100)).toFixed(2).toString(),
        enable: true,
        showTVL: false,
      },
    };
  } catch (error) {
    sentryErrorLog(error);
    return { error };
  }
};
